<template>
  <section class="filter-wrapper">
    <div class="filter" :class="{ open: filterModalOpen }" @click.stop="toggleFilterModal">
      <span>{{ $t('filters') }}</span>
      <span class="icon-badge" :class="{ hidden: appliedFiltersLength === 0 }">{{ appliedFiltersLength }}</span>
    </div>
    <div v-if="filterModalOpen" class="modal-wrapper flex-column" v-click-outside="{ handler: toggleFilterModal }">
      <div class="filter-modal flex-column">
        <header>
          <div class="filter-header">
            {{ $t('filters') }}
            <span class="icon-badge" :class="{ hidden: appliedFiltersLength === 0 }">{{ appliedFiltersLength }}</span>
            :
          </div>
          <div class="button-container">
            <div class="button" @click="updateFilterModal">{{ $t('apply') }}</div>
            <button v-if="appliedFiltersLength > 0" class="text-btn" @click="clearAllFilters">
              {{ $t('reset-all') }}
            </button>
          </div>
        </header>
        <div class="multi-container">
          <Collapsible
            v-for="[filterCategory, filterGroup] in filterEntriesMulti"
            :key="filterCategory"
            class="filter-list-multi"
            :title="formatTitle(filterCategory)"
            :hidden="!filterGroup"
            :initialOpen="false"
            :badge="activeMultiFilterCount(filterGroup)"
            :canToggle="!filterGroup.length ? false : true"
          >
            <ul>
              <li v-for="filter in filterGroup" :key="filter.label">
                <Checkbox
                  v-model="filter.checked"
                  :label="filter.label"
                  :type="filterCategory === 'exclusions' ? 'toggle' : 'checkbox'"
                />
              </li>
            </ul>
          </Collapsible>
        </div>
      </div>
    </div>
  </section>
</template>

<script>
import Checkbox from '@/components/Checkbox.vue';
import Collapsible from '@/components/Collapsible.vue';

export default {
  name: 'FilterModal',
  components: {
    Checkbox,
    Collapsible,
  },
  data() {
    return {
      filters: {},
      filterModalOpen: false,
      filtersMulti: {},
    };
  },
  props: {
    appliedFiltersLength: Number,
    valueMulti: Object,
  },
  computed: {
    filterEntriesMulti() {
      return Object.entries(this.filtersMulti).filter(([key]) => key !== 'length');
    },
  },
  watch: {
    valueMulti: {
      handler: function onFilterChange(newFilters) {
        this.filtersMulti = JSON.parse(JSON.stringify(newFilters));
      },
      deep: true,
      immediate: true,
    },
    filterModalOpen(isOpen) {
      if (isOpen) {
        this.filtersMulti = JSON.parse(JSON.stringify(this.valueMulti));
        this.$store.state.filterModalOpen = true;
      } else {
        this.$store.state.filterModalOpen = false;
      }
    },
  },
  methods: {
    toggleFilterModal() {
      this.filterModalOpen = !this.filterModalOpen;
    },
    updateFilterModal() {
      this.$emit('updateMulti', this.filtersMulti);
      this.filterModalOpen = !this.filterModalOpen;
    },
    clearAllFilters() {
      this.filtersMulti = this.valueMulti;
      this.$emit('clear-filters');
    },
    formatTitle(filterCategory) {
      // format camelcase to have spaces in between words
      return filterCategory.replace(/([a-z0-9])([A-Z])/g, '$1 $2');
    },
    activeFilterCount(filterGroup) {
      return filterGroup.filter((filter) => filter.checked).length;
    },
    activeMultiFilterCount(filterGroup) {
      return filterGroup.filter((filter) => filter.checked).length;
    },
  },
};
</script>

<style lang="scss" scoped>
.toggle {
  padding: 10px 0;
  ::v-deep {
    label {
      white-space: nowrap;
    }
  }
}
.filter-wrapper {
  position: relative;
  z-index: 5;
}
.filter {
  text-align: left;
  height: 38px !important;
  padding: 0 0 0 15px !important;
  cursor: pointer;
  color: $primary-black;
  background: $primary-white;
  display: flex;
  align-items: center;
  border: 1px solid #898c8d;
  padding: 7px 55px 9px 15px;
  height: auto;

  &::after {
    content: '';
    background-image: url('../assets/icons/carrot_down.svg?external');
    background-repeat: no-repeat;
    background-size: 16px 8px;
    width: 16px;
    height: 8px;
    transition: transform 100ms;
    margin: 10px;
  }
  &.open::after {
    transform: rotate(180deg);
  }
  span {
    vertical-align: middle;
  }
  .icon-badge {
    margin-left: 5px;
    vertical-align: middle;
    font-size: 14px;
    padding: 4px 8px;
    border-radius: 25px;
    background: $primary !important;
    color: $primary-white !important;
    &.hidden {
      visibility: hidden;
    }

    @include bp-lg-laptop {
      margin-left: 10px;
    }
  }
}
.modal-wrapper {
  background: $primary-white;

  text-align: left;
  overflow: auto;
  position: fixed;
  top: 0;
  right: 0;
  width: 100%;
  height: 100%;
  z-index: 10000;
  transform-origin: 100% 0;
  @include bp-lg-laptop {
    flex-direction: row;
    border-radius: 3px 0 3px 3px;
    justify-content: space-between;
    padding: 25px;
    position: absolute;
    top: 42px;
    width: auto;
    height: auto;
    z-index: 999;

    .filter-modal > section:not(:last-child) {
      margin-right: 50px;
    }
  }
  .filter-modal {
    @include bp-lg-laptop {
      display: flex;
      max-height: 300px;
      overflow-y: auto;
      font-size: 14px;
    }
    ::v-deep {
      h3 {
        font-size: 14px !important;
        padding-left: 20px;
        white-space: nowrap;
      }
      label {
        font-size: 14px;
      }
      .icon-badge {
        font-size: 14px;
        background: $primary;
        color: $primary-white;
      }
      @include bp-lg-laptop {
        border-top: 0;

        h3 {
          font-size: 22px;
          border: 0;
          box-shadow: none;
          margin-bottom: 15px;
          padding: 0;
          background: transparent;
          font-weight: normal;
          color: $primary-white;

          span {
            vertical-align: baseline;
          }
          &::after {
            content: ':';
            background: none;
            position: static;
            vertical-align: baseline;
          }
        }
        .icon-badge {
          padding: 4px 8px;
          border-radius: 25px;
        }
        .collapsible-content {
          background: none;
          box-shadow: none;
          max-height: none;
          padding: 0;
          //text-transform: uppercase;
        }
      }
    }
    header {
      display: flex;
      justify-content: space-between;
      align-items: center;
      text-align: center;
      position: relative;
      z-index: 3;
      margin-bottom: 20px;

      h2 {
        font-size: 2rem;
        font-weight: 300;
        line-height: 1.2;
        margin: 0;
        padding: 18px 0;
      }
      button {
        background: none;
        border: 0;

        &.icon {
          left: 0;
          padding: 21px;

          svg {
            display: block;
            width: 18px;
            height: 18px;
          }
        }
        &.text-btn {
          color: white;
          font-size: 12px;
          padding: 8px 9px;
          right: 0;
          background-color: $primary;
          width: auto;
          margin-left: 10px;
        }
      }
    }
    .multi-container {
      display: flex;
    }
  }
}
.modal-wrapper {
  display: flex;
  flex-direction: column !important;
  .button-container {
    display: flex;
    justify-content: flex-end;
    color: black;
    @include bp-lg-laptop {
      padding: 0;
    }
    padding: 20px;
    .button {
      width: 98px !important;
      background-color: $primary;
      border-radius: 18px;
      font-weight: bold;
      text-align: center;
      padding: 8px 0px;
      color: white;
      text-transform: uppercase;
      font-size: 12px;
      cursor: pointer;
      transition: all 0.2s ease;
      &:hover {
        background-color: $primary-button-hover;
      }
    }
  }
}
.filter-modal {
  .filter-list {
    border-top: 1px solid $border;
    @media only screen and (max-width: 1000px) {
      margin-top: 75px;
    }
    ::v-deep {
      h3 {
        padding-left: 20px;
        color: black !important;
        white-space: nowrap;
      }
      label {
        color: black;
      }
      label::before {
        border: 1px solid black;
      }
      .icon-badge {
        font-size: 14px;
        background: $primary;
        color: $primary-white;
      }
      @include bp-lg-laptop {
        border-top: 0;

        h3 {
          font-size: 22px;
          border: 0;
          box-shadow: none;
          margin-bottom: 15px;
          padding: 0;
          background: transparent;
          font-weight: normal;
          color: $primary-white;

          span {
            vertical-align: baseline;
          }
          &::after {
            content: ':';
            background: none;
            position: static;
            vertical-align: baseline;
          }
        }
        .icon-badge {
          display: none;
        }
        .collapsible-content {
          background: none;
          box-shadow: none;
          max-height: none;
          padding: 0;
          //text-transform: uppercase;
        }
      }
    }
  }
  .filter-list-multi {
    border-top: 1px solid $border;
    @media only screen and (max-width: 1000px) {
      margin-top: 75px;
    }
    ::v-deep {
      h3 {
        padding-left: 20px;
        color: black !important;
        white-space: nowrap;
      }
      label {
        color: black;
      }
      label::before {
        border: 1px solid black;
      }
      .icon-badge {
        font-size: 14px;
        background: $primary;
        color: $primary-white;
      }
      ul {
        margin: 0px;
        padding: 0px;
      }
      li {
        display: block;
        margin-bottom: 20px;
        padding: 0 10px;
      }
      @include bp-lg-laptop {
        border-top: 0;

        h3 {
          font-size: 22px;
          border: 0;
          box-shadow: none;
          margin-bottom: 15px;
          padding: 0;
          background: transparent;
          font-weight: normal;
          color: $primary-white;

          span {
            vertical-align: baseline;
          }
          &::after {
            content: ':';
            background: none;
            position: static;
            vertical-align: baseline;
          }
        }
        .icon-badge {
          display: none;
        }
        .collapsible-content {
          background: none;
          box-shadow: none;
          max-height: none;
          padding: 0;
          z-index: 999;
          background: white;
          padding-top: 20px;
          overflow: auto !important;
          position: fixed !important;
          max-height: 400px !important;
          //text-transform: uppercase;
        }
      }
    }
  }
  .filter-toggles h3,
  .filter-toggles ::v-deep label {
    font-size: 1.6rem;
    font-weight: 300;
    display: block;
    margin: 0;
    padding: 22px 20px 26px 28px;
    position: relative;
    z-index: 2;

    @include bp-lg-laptop {
      font-size: 2rem;
      border: 0;
      box-shadow: none;
      padding: 0;
    }
    .icon-badge {
      margin-top: 0.125em;
      margin-left: 10px;
      position: absolute;

      @include bp-lg-laptop {
        display: none;
      }
    }
  }
  .filter-list {
    flex: 1 1 0;
    @include bp-lg-laptop {
      // + .filter-list {
      //   margin-left: 50px;
      // }
    }
    ul {
      margin: 0;
      padding: 20px 0;
      position: relative;
      z-index: 1;

      @include bp-lg-laptop {
        background: none;
        padding: 0;
      }
      li {
        padding: 0 20px 0 28px;
        display: block;

        @include bp-lg-laptop {
          padding: 0;
        }
      }
      .checkbox {
        padding-top: 10px;
        padding-bottom: 10px;
      }
    }
  }
  .tracks-list {
    flex: 1.75 1 0 !important;
  }
  .filter-toggles {
    @include bp-lg-laptop {
      margin-left: 50px;
    }
    h3 {
      display: none;

      @include bp-lg-laptop {
        display: block;
        margin-bottom: 15px;

        &::after {
          content: ':';
        }
      }
    }
    ul {
      list-style-type: none;
      margin: 0;
      padding: 0;

      li {
        @include bp-lg-laptop {
          padding: 10px 0;
        }
      }
    }
    ::v-deep {
      label {
        @include bp-lg-laptop {
          font-size: inherit;
          padding-left: 70px;
        }
        span {
          position: relative;

          @include bp-lg-laptop {
            position: static;
          }
        }
      }
    }
  }
}
.sort-options {
  ul {
    list-style-type: none;
    margin: 0;
    padding: 0;

    li {
      font-size: 1.6rem;
      font-weight: 300;
      background-color: $primary-white;
      border-top: 1px solid $border;
      box-shadow: 0 4px 4px rgba(0, 0, 0, 0.16);
      display: block;
      margin: 0;
      padding: 0 60px 0 28px;
      position: relative;
      z-index: 2;
    }
    .checkbox {
      padding-top: 10px;
      padding-bottom: 10px;
    }
    ::v-deep label {
      padding-top: 10px;
      padding-bottom: 10px;
    }
  }
}
.slide {
  &-enter-active,
  &-leave-active {
    transition: all 300ms;
  }
  &-enter,
  &-leave-to {
    transform: translateX(100%);
  }
}
.scale {
  &-enter-active,
  &-leave-active {
    transition: all 300ms;
  }
  &-enter,
  &-leave-to {
    transform: scale(0);
  }
}
.filter-header {
  color: black;
  font-size: 20px;
}
</style>
